import { Grid, Hidden, withStyles } from "@material-ui/core";
import React from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ewbConfig } from "config";
import { ACTIONS, CATEGORIES, eventTracker, LABELS } from "utils/analytics";
import style from "style";
import BannerDetailsContainer from "./BannerDetailsContainer";
import BannerDetailsForMobile from "./BannerDetailsForMobile";

const Item = ({ classes, ...banner }) => {
  const trackBannerClick = () => {
    eventTracker(
      CATEGORIES.HOME_PAGE_CAROUSEL,
      ACTIONS.ENTRY_POINT_FROM_CAROUSEL,
      `${LABELS.NAVIGATE_FROM_HOME_PAGE_CAROUSEL_TO}_${banner.headerText}`
    );
  };
  return (
    <div>
      <section>
        <div
          id="carouselhomebanner"
          style={{
            background:
              "url(" +
              ewbConfig.appDomain +
              banner.image.replace(/\\\//g, "/") +
              ") no-repeat",
          }}
          key={banner.image}
          className={classes.bannerImg}
        >
          <Hidden smDown>
            <article>
              <Grid container className="gridContainer" spacing={0}>
                <Grid item xs={0} sm={0} md={6} lg={6}></Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <BannerDetailsContainer
                    {...banner}
                    trackBannerClick={trackBannerClick}
                  />{" "}
                </Grid>
              </Grid>
            </article>
          </Hidden>
        </div>
      </section>
      <Hidden mdUp>
        <BannerDetailsForMobile {...banner} />
      </Hidden>
    </div>
  );
};

export default withStyles(style)(Item);
